<template>
  <div class="language-selector">
    <n-select
      v-model:value="currentLocale"
      :options="languageOptions"
      size="medium"
      @update:value="changeLanguage"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { NSelect } from "naive-ui";
import { APP_LOCALE_KEY } from "@/utils/appLocaleConstants";

const languages = [
  { value: "es", label: "🇪🇸 Español" },
  { value: "en", label: "🇬🇧 English" },
  { value: "fr", label: "🇫🇷 Français" },
  { value: "de", label: "🇩🇪 Deutsch" },
  { value: "pt", label: "🇵🇹 Português" },
];

defineOptions({ name: "LanguageSelector" });
const { locale } = useI18n();

const currentLocale = computed({
  get: () => locale.value,
  set: (value: string) => {
    locale.value = value;
    localStorage.setItem(APP_LOCALE_KEY, value);
  },
});

const languageOptions = computed(() => languages);

function changeLanguage(value: string) {
  currentLocale.value = value;
}
</script>

<style lang="scss" scoped>
.language-selector {
  @apply flex items-center;
}

:deep(.n-select) {
  min-width: 150px;
}
</style>
